export default "__VITE_ASSET__wttkVnwk__"